// ユーザ詳細画面
import * as React from 'react';
// import * as PropTypes from 'prop-types';
// import * as Header from '../constants/Header';
import { Male, Female } from '../constants/UserListField';
import { PatientDetailHeader, DoctorDetailHeader, HospitalDetailHeader } from '../constants/UserDetails';
import { ageFromYmd, exportCSV, exportCSVCustom, exportJSON2CSV } from '../utils/commonUtil';
import * as moment from 'moment';
// import { Patient } from '../interfaces';
// import { Male, Female } from '../constants/UserListField';
// import { formatBirthday } from '../utils/dateUtil';
// import KirokuShow, { DummyKirokuShow } from './KirokuShow';
// import KirokuEdit from './KirokuEdit';
// import * as KirokuConst from '../constants/Kiroku';
// import { JS_VOID } from '../utils/commonUtil';
import { Table, Button, Dialog, Form, Input, Message, DatePicker, Select, Radio } from 'element-react';
import { Doctor, Hospital, Patient } from '../interfaces';
import { typeToName, actionTypeToName } from '../constants/Dialog';
import Back from './common/Back';
import 'element-theme-default';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/user_detail.css';
import '../css/input.css';

interface UserDetailProps extends React.Props<{}> {
  headerActions?: any;
  moffAPIActions: any;

  // 前ページのユーザーID.
  match?: any;
  moffAPI: any;
}

interface DetailState {
  startDate: string;
  columns: any;
  showDialog: boolean;
  showEditHospitalDialog: boolean;
  dialogType: string;
  dialogAction: string;
  doctorForm: Doctor;
  hospitalForm: Hospital;
  patientForm: Patient;
  endDate: string;
  data: any[];
}

// 詳細本体.
export default class UserDetails extends React.Component<
  UserDetailProps,
  DetailState
  > {
  static get childContextTypes() {
    return {
      // callbackParent: PropTypes.func,
    };
  }

  // filteredTraining: KirokuConst.Training[];
  userId: string;
  hospitalId: string;
  detailType: string;
  csvDataOfUser = [
    [],
    []
  ];
  csvDataOfResistance = {};
  fieldsOfResistance = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'patientDayTrainingResistanceLogs.resistanceNumber', 'patientDayTrainingResistanceLogs.name', 'patientDayTrainingResistanceLogs.level', 'patientDayTrainingResistanceLogs.stoppedCount', 'patientDayTrainingResistanceLogs.evaluation', 'patientDayTrainingResistanceLogs.depthRepsThreshold', 'patientDayTrainingResistanceLogs.depthSuccessThreshold', 'patientDayTrainingResistanceLogs.form', 'patientDayTrainingResistanceLogs.reps', 'patientDayTrainingResistanceLogs.sets', 'patientDayTrainingResistanceLogs.setLogs.isSuccess', 'patientDayTrainingResistanceLogs.setLogs.depth', 'patientDayTrainingResistanceLogs.setLogs.form', 'patientDayTrainingResistanceLogs.setLogs.startedAt', 'patientDayTrainingResistanceLogs.setLogs.finishedAt'];
  unwindOfResistance = ['patientDayTrainingResistanceLogs', 'patientDayTrainingResistanceLogs.setLogs'];
  csvDataOfAerobic = {};
  fieldsOfAerobic = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'aerobicLog.aerobicNumber', 'aerobicLog.name', 'aerobicLog.label', 'aerobicLog.min', 'aerobicLog.max', 'aerobicLog.aerobicMotionNumbers', 'aerobicLog.goalDurationMinutes', 'aerobicLog.stoppedCount', 'aerobicLog.actualDurationMinutes', 'aerobicLog.heartRateLogs.heartRates', 'aerobicLog.heartRateLogs.startedAt', 'aerobicLog.heartRateLogs.finishedAt'];
  unwindOfAerobic = ['aerobicLog', 'aerobicLog.heartRateLogs', 'aerobicLog.heartRateLogs.startedAt'];
  // 有酸素運動の心拍ログ出力カスタマイズの出力用配列
  csvDataOfAerobicCustom: string[][] = new Array();
  username: string;

  relatedTableHeader: {} = {
    hospital: '所属医師一覧',
    doctor: '所属顧客一覧',
    patient: '掛かり付け医'
  };
  relatedTableTransfer: {} = {
    hospital: 'doctors',
    doctor: 'patients',
    patient: 'doctors'
  };

  // 2重読み込み防止
  done = false;

  constructor(props: UserDetailProps) {
    super(props);

    // 開始(月初) YYYY-MM-DD
    let startYearMonthDay: string = moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    // 終わり(月末) YYYY-MM-DD
    let endYearMonthDay: string = moment()
      .endOf('month')
      .format('YYYY-MM-DD');

    this.state = {
      // 開始と終わり.
      startDate: startYearMonthDay,
      endDate: endYearMonthDay,
      showDialog: false,
      showEditHospitalDialog: false,
      doctorForm: {
        username: '',
        name: '',
        hospitalId: '',
        password: ''
      },
      hospitalForm: {
        id: '',
        name: ''
      },
      patientForm: {
        heartRate: 0,
        gender: 1,
        birthdayYmd: null,
        hospitalIds: [],
        username: '',
        password: ''
      },
      dialogType: '',
      dialogAction: '',
      columns: {
        hospital: [
          {
            label: 'ID',
            prop: 'id',
            width: 180,
            sortable: true
          },
          {
            label: '医師名',
            prop: 'name',
            width: 180,
            sortable: true
          },
          {
            label: '作成日',
            prop: 'createdAt'
          },
          {
            label: '操作',
            width: 120,
            fixed: 'right',
            render: (row, column, index) => {
              return <span><Button type="text" size="small" onClick={this.handleFieldClickDoctor.bind(this, index)}>詳細ページへ</Button></span>;
            }
          }
        ],
        patients: [
          {
            label: 'システムID',
            prop: 'id',
            width: 180,
            sortable: true
          },
          {
            label: 'ユーザID',
            prop: 'username',
            width: 180,
            sortable: true
          },
          {
            label: '生年月日',
            prop: 'birthdayYmd',
            width: 180
          },
          {
            label: '性別',
            props: 'gender',
            width: 180,
            render: (data) => {
              return this.getGender(data.gender);
            }
          },
          {
            label: '所属医療機関ID一覧',
            props: 'hospitalIds',
            width: 180,
            render: (data) => {
              return data.hospitalIds.map(val => {
                const url: string = `/hospital/${val}`;
                return <a key="val" href={url}>{val}</a>;
              });
            }
          },
          {
            label: '操作',
            width: 120,
            fixed: 'right',
            render: (row, column, index) => {
              return <span><Button type="text" size="small" onClick={this.handleFieldClickPatient.bind(this, index)}>詳細ページへ</Button></span>;
            }
          }
        ]
      },
      data: [
        {
          id: '1',
          name: 'taro',
          age: '18'
        },
        {
          id: '2',
          name: 'hanako',
          age: '18'
        }
      ]
    };
  }

  getChildContext() {
    // const callback: Function = (type: KirokuConst.type) => {
    //   this.setState({
    //     type: type,
    //   });
    // };
    // return {
    //   callbackParent: callback,
    // };
  }

  runAPI() {
    // URLのパラメータ.
    const userId: string = this.userId;
    if (this.detailType !== 'doctor') {
      this.props.moffAPIActions.getDetails(this.detailType, userId);
    }
    if (this.detailType === 'doctor') {
      this.props.moffAPIActions.getDoctorDetails(userId);
    }
    if (this.detailType === 'hospital') {
      this.props.moffAPIActions.getDoctorsBelongHospital(userId);
      this.props.moffAPIActions.getPatientsBelongHospital(userId);
    }
    if (this.detailType === 'patient') {
      this.props.moffAPIActions.getPatientDayTrainingLogs(userId);
    }
  }

  reduceHospitals() {
    return this.props.moffAPI.hospitals.map((v: Hospital) => {
      return {
        value: v.id,
        label: v.name
      };
    });
  }

  componentWillMount() {
    // URLのパラメータ.
    this.userId = this.props.match.params.userId;
    this.hospitalId = this.props.match.params.hospitalId;
    this.detailType = location.pathname.split('/')[1];
    document.title =
      this.detailType === 'doctor' ? '医師詳細画面' : (this.detailType === 'hospital' ? '医療機関詳細画面' : '顧客詳細画面');
    this.props.headerActions.setPage(this.detailType.toUpperCase() + '_DETAIL');
    // 最初に一回通信.
    this.runAPI();
  }

  addDoctor() {
    if (this.state.doctorForm.name.length > 3 && this.state.doctorForm.username.length > 3 && this.state.doctorForm.password.length > 5) {
      this.props.moffAPIActions.postAddDoctor(this.state.doctorForm);
      Message({
        type: 'success',
        duration: 5000,
        message: '医師の登録に成功しました'
      });
      this.initDoctorData();
    } else {
      Message({
        type: 'error',
        duration: 3000,
        message: '医師登録に失敗しました'
      });
    }
  }

  editHospital() {
    this.props.moffAPIActions.putUpdateHospital(this.state.hospitalForm);
  }

  editDoctor() {
    this.props.moffAPIActions.putUpdateDoctor(this.state.doctorForm);
  }

  editPatient() {
    this.props.moffAPIActions.putUpdatePatient(this.state.patientForm);
  }

  initData() {
    if (this.detailType === 'hospital') {
      this.initDoctorData();
      this.initHospitalData();
    } else if (this.detailType === 'doctor') {
      this.initDoctorData();
    } else {
      this.initPatientData();
    }
  }

  initPatientData() {
    let patientForm = this.props.moffAPI.patientDetails;
    this.setState({
      patientForm: patientForm
    });
  }

  initDoctorData() {
    if (this.state.dialogAction === 'add') {
      this.setState({
        doctorForm: {
          username: '',
          name: '',
          hospitalId: this.userId,
          password: ''
        }
      });
    } else {
      this.setState({
        doctorForm: this.props.moffAPI.doctorDetails
      });
    }
  }

  initHospitalData() {
    this.setState({
      hospitalForm: {
        id: this.userId,
        name: this.props.moffAPI.hospitalDetails.name
      }
    });
  }

  handleFieldClicked = (index: number) => {
    const targetId = this.props.moffAPI.doctors[index].id;
    window.location.href = `/doctor/${targetId}/${this.userId}`;
  }

  handleFieldClickDoctor = (index: number) => {
    const targetId = this.props.moffAPI.doctors[index].id;
    window.location.href = `/doctor/${targetId}/${this.userId}`;
  }

  handleFieldClickPatient = (index: number) => {
    const targetId = this.props.moffAPI.patients[index].id;
    window.location.href = `/patient/${targetId}`;
  }

  onChange(key: string, value: any) {
    if (this.state.dialogType === 'doctor') {
      this.state.doctorForm[key] = value;
    } else if (this.state.dialogType === 'hospital') {
      this.state.hospitalForm[key] = value;
    } else {
      this.state.patientForm[key] = value;
    }
    this.forceUpdate();
  }

  onSubmit() {
    if (this.state.dialogAction === 'edit') {
      if (this.state.dialogType === 'doctor') {
        // this.editDoctor();
        return null;
      } else if (this.state.dialogType === 'hospital') {
        this.editHospital();
      } else {
        this.editPatient();
      }
    } else {
      if (this.state.dialogType === 'doctor') {
        this.addDoctor();
      } else {
        return null;
      }
    }
    this.toggleShowDialog();
  }

  toggleShowDialog(dialogType?: string, dialogAction?: string) {
    if (this.state.showDialog) {
      this.setState({ showDialog: false });
      this.initData();
    } else {
      this.setState({
        showDialog: true,
        dialogType: dialogType,
        dialogAction: dialogAction
      },
        () => this.initData());
    }
  }

  createAerobicCustomCsv() {
    // 有酸素運動のcsvデータカスタマイズ
    const { Parser } = require('json2csv');
    const json2csvParser = new Parser({ fields: this.fieldsOfAerobic , flattern: true, unwind: this.unwindOfAerobic});
    let aerobicData;
    try {
      aerobicData = json2csvParser.parse(this.csvDataOfAerobic); 
    } catch (error) {
      console.log(error);
    }
    // 出力のための変数
    let splitedHeartRates;
    let heartRateLogsStartedAt;
    let columnValues = [];
    let lineCounter = 0;
    // csvを入力配列に読み込む
    let heartRateLogsIndex;
    let heartRateLogsStartedAtIndex;
    let dayTrainingNumberIndex;
    let trainingNumberIndex;
    let startedAtIndex;
    let finishedAtIndex;
    let evaluationIndex;
    let aerobicNumberIndex;
    let nameIndex;
    let labelIndex;
    let minIndex;
    let maxIndex;
    // let aerobicMotionNumbersIndex;
    let goalDurationMinutesIndex;
    let stoppedCountIndex;
    // let actualDurationMinutesIndex;
    // let heartRateLogsFinishedAtIndex;
    const csv2array  = require('csv2array');
    csv2array(aerobicData).forEach((line, index) => {
      if (index === 0) {
        // ヘッダ
        let writeLine = '';
        // tslint:disable-next-line: forin
        for (let key in line) {
          if (line[key] === 'aerobicLog.heartRateLogs.heartRates') {
            heartRateLogsIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.heartRateLogs.startedAt') {
            heartRateLogsStartedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'dayTrainingNumber') {
            dayTrainingNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'trainingNumber') {
            trainingNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'startedAt') {
            startedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'finishedAt') {
            finishedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'evaluation') {
            evaluationIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.aerobicNumber') {
            aerobicNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.name') {
            nameIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.label') {
            labelIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.min') {
            minIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.max') {
            maxIndex = key;
            writeLine += line[key] + ',';
          // } else if (line[key] === 'aerobicLog.aerobicMotionNumbers') {
          //   aerobicMotionNumbersIndex = key;
          } else if (line[key] === 'aerobicLog.goalDurationMinutes') {
            goalDurationMinutesIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.stoppedCount') {
            stoppedCountIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.actualDurationMinutes') {
          //   actualDurationMinutesIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.heartRateLogs.finishedAt') {
          //   heartRateLogsFinishedAtIndex = key;
            writeLine += line[key];
          }
        }
        // ヘッダ
        this.csvDataOfAerobicCustom[lineCounter] = [];
        this.csvDataOfAerobicCustom[lineCounter].push(writeLine);
        lineCounter += 1;
      } else {
        // 2行目以降の処理
        // 心拍数を配列に入れる
        for (let key in line) {
          //  各項目の値を保存
          if (key ===  heartRateLogsIndex) {
            splitedHeartRates = line[key];
            columnValues.push(line[key]);
          } else if (key === startedAtIndex) {
            columnValues.push(line[key]);
          } else if (key === heartRateLogsStartedAtIndex) {
            heartRateLogsStartedAt = line[key];
            columnValues.push(line[key]);
          } else {
            columnValues.push(line[key]);
          }
        }
        splitedHeartRates = splitedHeartRates.replace('[', '');
        splitedHeartRates = splitedHeartRates.replace(']', '');
        splitedHeartRates = splitedHeartRates.split(',');
        // 1秒ごとの心拍数の値で1列を作る
        let timeCounter = 0;
        for (let key in splitedHeartRates) {
          if (splitedHeartRates[key]) {
            let writeLine = columnValues[dayTrainingNumberIndex] + ',' +
                columnValues[trainingNumberIndex] + ',' +
                columnValues[startedAtIndex] + ',' +
                columnValues[finishedAtIndex] + ',' +
                columnValues[evaluationIndex] + ',' +
                columnValues[aerobicNumberIndex] + ',' +
                columnValues[nameIndex] + ',' +
                columnValues[labelIndex] + ',' +
                columnValues[minIndex] + ',' +
                columnValues[maxIndex] + ',' +
                // columnValues[aerobicMotionNumbersIndex] + ',' +
                columnValues[goalDurationMinutesIndex] + ',' +
                columnValues[stoppedCountIndex] + ',' +
                '1,';
            writeLine = writeLine + splitedHeartRates[key] + ',';
            writeLine = writeLine + moment(heartRateLogsStartedAt).add(timeCounter, 's').format('YYYY-MM-DD HH:mm:ss').toString() + ',';
            writeLine = writeLine + moment(heartRateLogsStartedAt).add(timeCounter + 1, 's').format('YYYY-MM-DD HH:mm:ss').toString();
            timeCounter += 1;
            // 出力用配列をCSVに書き出し
            this.csvDataOfAerobicCustom[lineCounter] = [];
            this.csvDataOfAerobicCustom[lineCounter].push(writeLine);
            lineCounter += 1;
          }
        }
        columnValues = [];
      }
    });
  }
  
  render() {
    let className: string = 'detail-wrap';
    let userMetas = [];

    if (this.props.moffAPI.Loaded) {
      const header: any = this.detailType === 'doctor' ? DoctorDetailHeader : (this.detailType === 'patient' ? PatientDetailHeader : HospitalDetailHeader);
      const details = this.props.moffAPI[`${this.detailType}Details`];
      for (const key in details) {
        if (details.hasOwnProperty(key)) {
          this.csvDataOfUser[0].push(key);
          this.csvDataOfUser[1].push(details[key]);
          if (key === 'username') {
            this.username = details[key];
          }
          if (key === 'birthdayYmd') {
            userMetas.push(
              <tr key={key}>
                <th>{header[key]}</th>
                {/* <td>{details[key]}({calcAge(details[key])}歳)</td> */}
                <td>{details[key]} ({ageFromYmd(details[key])}歳)</td>
              </tr>
            );
            continue;
          }
          if (key === 'gender') {
            userMetas.push(
              <tr key={key}>
                <th>{header[key]}</th>
                <td>{this.getGender(details[key])}</td>
              </tr>
            );
            continue;
          }
          userMetas.push(
            <tr key={key}>
              <th>{header[key]}</th>
              <td>{details[key]}</td>
            </tr>
          );
        }
      }

      // 運動実施ログからcsvをつくる
      let dayTrainingLogs = this.props.moffAPI.patientDayTrainingLogs;
      let trainingLogs;
      if (dayTrainingLogs.patientDayTrainingLogs) {
        trainingLogs = dayTrainingLogs.patientDayTrainingLogs;
      } else {
        trainingLogs = dayTrainingLogs;
      }
      const keyOfResistance = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'patientDayTrainingResistanceLogs'];
      let dayOfResistance = [];
      if (trainingLogs && !this.done) { 
        if (trainingLogs && trainingLogs.length > 0) {
          this.done = true;
          trainingLogs.forEach(element => {
            let row = {};
            keyOfResistance.forEach(key => {
              if (key === 'startedAt' || key === 'finishedAt') {
                row[key] = moment(element[key]).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
              } else if (key === 'patientDayTrainingResistanceLogs') {
                element[key].forEach(set => {
                  set.setLogs.forEach(log => {
                    const startedAt = moment(log.startedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                    log.startedAt = startedAt;
                    const finishedAt = moment(log.finishedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                    log.finishedAt = finishedAt;
                  });
                });
                row[key] = element[key];
              } else {
                row[key] = element[key];
              }
            });
            dayOfResistance.push(row);
          });
          this.csvDataOfResistance = dayOfResistance;

          const keyOfAerobic = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'aerobicLog'];
          let dayOfAerobic = [];
          trainingLogs.forEach(element => {
            let row = {};
            keyOfAerobic.forEach(key => {
              if (key === 'startedAt' || key === 'finishedAt') {
                row[key] = moment(element[key]).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
              } else if (key === 'aerobicLog') {
                element[key].heartRateLogs.forEach(log => {
                  log.startedAt = moment(log.startedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                  log.finishedAt = moment(log.finishedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                });
                row[key] = element[key];
              } else {
                row[key] = element[key];
              }
            });
            dayOfAerobic.push(row);
          });
          this.csvDataOfAerobic = dayOfAerobic;

          // 有酸素運動のcsvデータカスタマイズ
          this.createAerobicCustomCsv();
          
        }
      }
    }

    return (
      <div>
        <style type="text/css">
          {/* 縦印刷, 日付・title名ヘッダの余白 */}
          {'@media print{@page {size: portrait; margin-top: 43px;}}'}
          {'@media print{#wrapper { padding:0; margin: 0; } header { display: none; }}'}
          {'@media print{.contentIn { padding-top:0!important; padding-bottom:0!important; }}'}
          {'@media print{.report { padding-bottom:0!important; }}'}
          {/* Edge対策 */}
          {'@media print{tr { page-break-inside: avoid; }}'}
          {'#wrapper .contentIn { padding-top: 80px; }'}
          {'h3 { margin-top: 15px; }'}
          {'h3 small { font-size: 13px;color: gray; margin: 8px 0;}'}
          {'.related-table h3 { display: flex; align-items: center;}'}
          {'.related-table h3 .btnStyle02 {margin-left: 16px;}'}
        </style>
        <Back />
        <Dialog
          title={`${typeToName[this.state.dialogType]}${actionTypeToName[this.state.dialogAction]}`}
          size="tiny"
          visible={this.state.showDialog}
          onCancel={() => this.toggleShowDialog()}
          lockScroll={false}
        >
          <Dialog.Body>
            {this.state.dialogType === 'doctor' &&
              <p>
                ※医師名、ユーザ名は３文字以上
                パスワードは英数字６文字以上で入力をお願いします
              </p>
            }
            {
              this.state.dialogType === 'doctor' &&
              <Form model={this.state.doctorForm} labelWidth="120">
                <Form.Item label="医師名">
                  <Input value={this.state.doctorForm.name} placeholder="山田太郎" onChange={this.onChange.bind(this, 'name')} />
                </Form.Item>
                <Form.Item label="ユーザ名">
                  <Input value={this.state.doctorForm.username} placeholder="yamada.taro" onChange={this.onChange.bind(this, 'username')} />
                </Form.Item>
                <Form.Item label="所属医療機関ID">
                  <Input value={this.state.doctorForm.hospitalId} readOnly={true} onChange={this.onChange.bind(this, 'hospitalId')} />
                </Form.Item>
                <Form.Item label="パスワード">
                  <Input value={this.state.doctorForm.password} onChange={this.onChange.bind(this, 'password')} />
                </Form.Item>
              </Form>
            }
            {
              this.state.dialogType === 'hospital' &&
              <Form model={this.state.hospitalForm} labelWidth="120">
                <Form.Item label="医師名">
                  <Input value={this.state.hospitalForm.name} placeholder="moff病院" onChange={this.onChange.bind(this, 'name')} />
                </Form.Item>
              </Form>
            }
            {
              this.state.dialogType === 'patient' &&
              <Form model={this.state.patientForm} labelWidth="120">
                <Form.Item label="ユーザID">
                  <Input value={this.state.patientForm.username} onChange={this.onChange.bind(this, 'username')} />
                </Form.Item>
                <Form.Item label="パスワード">
                  <Input value={this.state.patientForm.password} onChange={this.onChange.bind(this, 'password')} />
                </Form.Item>
                <Form.Item label="生年月日">
                  <DatePicker
                    value={new Date(this.state.patientForm.birthdayYmd)}
                    placeholder="生年月日を選択してください"
                    onChange={this.onChange.bind(this, 'birthdayYmd')}
                  />
                </Form.Item>
                <Form.Item label="所属医療機関">
                  <Select placeholder="所属医療機関を選択してください" value={this.state.patientForm.hospitalIds} multiple={true} onChange={this.onChange.bind(this, 'hospitalIds')}>
                    {
                      this.reduceHospitals().map(el => {
                        return <Select.Option key={el.value} label={el.label} value={el.value} />;
                      })
                    }
                  </Select>
                </Form.Item>
                <Form.Item label="性別">
                  <Radio value="1" checked={Number(this.state.patientForm.gender) === 1} onChange={this.onChange.bind(this, 'gender')}>男性</Radio>
                  <Radio value="2" checked={Number(this.state.patientForm.gender) === 2} onChange={this.onChange.bind(this, 'gender')}>女性</Radio>
                </Form.Item>
                <Form.Item label="安静時心拍数">
                  <Input value={this.state.patientForm.heartRate} onChange={this.onChange.bind(this, 'heartRate')} />
                </Form.Item>
              </Form>
            }
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button onClick={() => this.toggleShowDialog()}>キャンセル</Button>
            <Button type="primary" onClick={() => this.onSubmit()}>{`${typeToName[this.state.dialogType]}${actionTypeToName[this.state.dialogAction]}`}</Button>
          </Dialog.Footer>
        </Dialog>

        <article className={className}>
          <div className="user">
            <table>
              {userMetas}
            </table>
            <div className="btnStyle02">
              <Button size="large" type="primary" onClick={() => this.toggleShowDialog(this.detailType, 'edit')}>
                {this.detailType === 'doctor' && '医師情報を編集'}
                {this.detailType === 'patient' && '顧客情報を編集'}
                {this.detailType === 'hospital' && '医療機関情報を編集'}
              </Button>
            </div>
            {this.detailType === 'patient' && <hr />}
            {(() => {
              if (this.detailType === 'patient') {
                return (
                  <div className="btnStyle02">
                    <Button type="primary" onClick={() => exportCSV(this.csvDataOfUser)}>顧客情報csv</Button>
                    <style type="text/css">
                      {'.btnStyle02 button { margin: 0 auto;display:block; }'}
                    </style>
                    <br />
                    <Button type="primary" onClick={() => exportJSON2CSV(this.csvDataOfResistance, this.username + '-resistanceLog', this.fieldsOfResistance, this.unwindOfResistance)}>レジスタンス運動csv</Button>
                    <style type="text/css">
                      {'.btnStyle02 button { margin: 0 auto;display:block; }'}
                    </style>
                    <br />
                    <Button type="primary" onClick={() => exportJSON2CSV(this.csvDataOfAerobic, this.username + '-aerobicLog', this.fieldsOfAerobic, this.unwindOfAerobic)}>有酸素運動データcsv</Button>
                    <style type="text/css">
                      {'.btnStyle02 button { margin: 0 auto;display:block; }'}
                    </style>
                    <br />
                    <Button type="primary" onClick={() => exportCSVCustom(this.csvDataOfAerobicCustom, this.username + '-aerobicLogCustom')}>有酸素運動データcsv(縦)</Button>
                    <style type="text/css">
                      {'.btnStyle02 button { margin: 0 auto;display:block; }'}
                    </style>
                  </div>
                );
              } else {
                return null;
              }
            })()}
          </div>
        </article>
        {/* {this.detailType === 'doctor' && (
          <div className="search-wrap">
            <div className="search-design">
              <input type="text" placeholder="絞り込み検索" />
              <img src={searchImg} width="20" height="20" />
            </div>
          </div>
        )} */}
        {(this.detailType !== 'doctor' && this.detailType !== 'patient') &&
          <div className="related-table">
            <h3>
              {
                this.relatedTableHeader[this.detailType]
              }
              {this.detailType === 'hospital' &&
                <div className="btnStyle02">
                  <Button type="primary" onClick={() => this.toggleShowDialog('doctor', 'add')}>医師登録</Button>
                </div>
              }
            </h3>
            <Table
              style={{ width: '100%' }}
              columns={this.state.columns[this.detailType]}
              data={this.props.moffAPI[this.relatedTableTransfer[this.detailType]]}
              border={false}
            />
          </div>
        }
        {this.detailType === 'hospital' &&
          <div className="related-table">
            <h3>
              所属顧客一覧
          <br />
              <small>
                ※以下のテーブルは横にスクロールできます
          </small>
            </h3>
            <Table
              style={{ width: '100%' }}
              columns={this.state.columns.patients}
              data={this.props.moffAPI.patients}
              border={false}
            />
          </div>
        }
      </div>
    );
  }

  /**
   * 男性、女性表示.
   *
   * @param {number} gender
   * @returns {string}
   * @memberof MoffCheck
   */
  private getGender(gender: number): string {
    return `${gender === 1 ? Male : Female}性`;
  }
}



// WEBPACK FOOTER //
// ./src/components/UserDetails.tsx